import * as v1 from './2021-11-18-000000_0-1.js';
import * as v2 from './2021-11-18-000001_1-2.js';
import * as v3 from './2021-12-02-153120_flatten-output.js';
import * as v4 from './2022-01-26-121827_remove-outros.js';
import * as v5 from './2022-02-18-151350_add-layer-property.js';
import * as v6 from './2022-03-17-102454_normalize-storyboard.js';
import * as v7 from './2022-08-03-093056_brands-2.js';
import * as v8 from './2022-08-15-105752_text-variants.js';

export default [
  v1,
  v2,
  v3,
  v4,
  v5,
  v6,
  v7,
  v8,
];
